import * as types from './MyFriendsActionTypes';

// SEND FRIENDS REQUEST

export const sendFriendsRequest = (email) => ({
  type: types.SEND_FRIENDS_REQUEST,
  email,
});

export const setSendFriendRequestWaiting = (value) => ({
  type: types.SET_SEND_FRIEND_REQUEST_WAITING,
  value,
});

export const setSendFriendRequestSuccess = (value) => ({
  type: types.SET_SEND_FRIEND_REQUEST_SUCCESS,
  value,
});

export const setSendFriendRequestMessage = (message) => ({
  type: types.SET_SEND_FRIEND_REQUEST_MESSAGE,
  message,
});

// GET FRIENDS LIST

export const loadFriends = (skip, limit) => ({
  type: types.LOAD_FRIENDS,
  skip,
  limit,
});

export const setLoadFriendsWaiting = (value) => ({
  type: types.SET_LOAD_FRIENDS_WAITING,
  value,
});

export const setTotalFriendsCount = (count) => ({
  type: types.SET_TOTAL_FRIENDS_COUNT,
  count,
});

export const setFriends = (friends) => ({
  type: types.SET_FRIENDS,
  friends,
});

// REMOVE FRIEND
export const removeFriend = (friendId) => ({
  type: types.REMOVE_FRIEND,
  friendId,
});

export const setRemoveFriendWaiting = (value) => ({
  type: types.SET_REMOVE_FRIEND_WAITING,
  value,
});

export const setRemoveFriendSuccess = (value) => ({
  type: types.SET_REMOVE_FRIEND_SUCCESS,
  value,
});

export const setRemoveFriendMessage = (message) => ({
  type: types.SET_REMOVE_FRIEND_MESSAGE,
  message,
});

export const removeFriendFromLocalList = (friendId) => ({
  type: types.REMOVE_FRIEND_FROM_LOCAL_LIST,
  friendId,
});

// RESOLVE FRIEND REQUEST
export const resolveFriendRequest = (id, status) => ({
  type: types.RESOLVE_FRIEND_REQUEST,
  id,
  status,
});

export const setResolveFriendRequestWaiting = (value) => ({
  type: types.SET_RESOLVE_FRIEND_REQUEST_WAITING,
  value,
});

export const setResolveFriendRequestSuccess = (value) => ({
  type: types.SET_RESOLVE_FRIEND_REQUEST_SUCCESS,
  value,
});

export const setResolveFriendRequestMessage = (message) => ({
  type: types.SET_RESOLVE_FRIEND_REQUEST_MESSAGE,
  message,
});

// OTHER
export const resetFriendsObject = () => ({
  type: types.RESET_FRIENDS_OBJECT,
});

export const setFriendRequestNotifications = (notifications) => ({
  type: types.SET_FRIEND_REQUEST_NOTIFICATIONS,
  notifications,
});

// GET REQUEST NOTIFICATIONS
export const getFriendRequestNotifications = () => ({
  type: types.LOAD_FRIEND_REQUEST_NOTIFICATIONS,
});
